import { useEffect, useState } from "react";
import { Ruler, Search, RotateCcw, ChevronDown } from "lucide-react";
import DimDrawing from "@/components/dims/DimDrawing";

export default function DimensionSearch({ config, value, onApply }) {
    const [vals, setVals] = useState(value || {});
    const [open, setOpen] = useState(true);
    useEffect(() => setVals(value || {}), [value]);

    const set = (k, v) => setVals((s) => ({ ...s, [k]: v }));
    const apply = (e) => {
        e?.preventDefault();
        const clean = Object.fromEntries(Object.entries(vals).filter(([, v]) => String(v).trim()));
        onApply(clean);
    };
    const reset = () => { setVals({}); onApply({}); };
    const active = Object.keys(value || {}).length;

    return (
        <form onSubmit={apply} className="fx-panel mb-6 overflow-hidden" data-testid="dimension-search">
            <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 border-b border-slate-200" data-testid="dimension-search-toggle">
                <span className="flex items-center gap-2 font-display font-black uppercase tracking-tight">
                    <Ruler className="w-4 h-4 text-[hsl(var(--primary))]" /> Kërko sipas dimensioneve
                    {active > 0 && <span className="text-[10px] font-mono px-1.5 py-0.5 rounded bg-[hsl(var(--primary)/0.12)] text-[hsl(var(--primary))]">{active} aktive</span>}
                </span>
                <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
                <div className="p-4 grid lg:grid-cols-[260px_1fr] gap-6 items-start">
                    <div className="space-y-2">
                        <p className="text-xs text-slate-500">
                            Vendosni dimensionet e njohura. * Toleranca e lejuar: <b className="text-slate-800" data-testid="dimension-tolerance">±{config.tolerance} mm</b>
                        </p>
                        {(config.fields || []).map((f) => (
                            <label key={f.key} className="flex items-center gap-2">
                                <span className="w-14 shrink-0 font-display font-black text-sm">{f.key}</span>
                                <span className="flex-1 text-[11px] text-slate-500 truncate">{f.label}</span>
                                <input
                                    type="text"
                                    inputMode="decimal"
                                    placeholder={f.key.toLowerCase() === "blades" ? "nr" : "mm"}
                                    value={vals[f.key] || ""}
                                    onChange={(e) => set(f.key, e.target.value)}
                                    className="input-field !w-24 !py-1.5 font-mono"
                                    data-testid={`dimension-input-${f.key}`}
                                />
                            </label>
                        ))}
                        <div className="flex gap-2 pt-2">
                            <button type="submit" className="btn-primary flex-1 !py-2" data-testid="dimension-search-submit"><Search className="w-4 h-4" /> Kërko</button>
                            <button type="button" onClick={reset} className="btn-outline !py-2" data-testid="dimension-search-reset"><RotateCcw className="w-4 h-4" /></button>
                        </div>
                    </div>
                    <div className="hidden md:block px-6 py-4 bg-white rounded-lg">
                        <DimDrawing config={config} values={vals} onChange={set} />
                    </div>
                </div>
            )}
        </form>
    );
}
